module.exports = __webpack_public_path__ + "static/img/SF108_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF108_1.png
// module id = 8Gdo
// module chunks = 0